import React, { useEffect } from "react";
import "./Notification.scoped.scss";
import { setNotification } from "core/store/actionCreators";
import useStore from "core/custom-hooks/useStore";

const Notification = () => {
    const { state, dispatch } = useStore();
    const { notification } = state;
    const {
        mainTitle,
        subTitle,
        ButtonImage,
        closingAction,
        isOpen,
        tagManagerPush,
    } = notification;

    const resetScrollPosition = () => {
        document.body.style.overflow = "auto";
    };

    useEffect(() => {
        if (isOpen === true) {
            setTimeout(() => close(false), 6000)
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    const close = (shouldCallClosingAction) => {
        shouldCallClosingAction &&
            typeof closingAction === "function" &&
            closingAction();
        resetScrollPosition();
        dispatch(setNotification({ isOpen: false }));
    };

    return (
        <div className="smart-banner-container popup_wrap">
            <div className="textual-area">
                <span>{mainTitle}</span>
                <span>{subTitle}</span>
            </div>
            <div className="image-area">
                <a href={ButtonImage.url}>
                    <img
                        src={ButtonImage.img}
                        alt="icon"
                    />
                </a>
            </div>
            <div className="popup_close_icon" onClick={() => close(false)}>
                <a href="#" onClick={(e) => e.preventDefault()}>
                    <i className="fa ion-android-close"></i>
                </a>
            </div>
            <span className="mat-ripple mat-button-ripple mat-button-ripple-round" />
            <span className="mat-button-focus-overlay" />
        </div>
    );
};

export default Notification;

export const sendNotification = (
    dispatch,
    mainTitle,
    subTitle,
    ButtonImage,
    closingAction,
    tagManagerPush,
) => {
    // document.body.style.overflow = "hidden";
    dispatch(
        setNotification({
            isOpen: true,
            mainTitle,
            subTitle,
            ButtonImage,
            closingAction,
            tagManagerPush,
        })
    );
};
